import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom';

// if (config.STAGE === 'demo' && !config.IS_DEVELOPMENT) {
//   Sentry.init({
//     dsn: config.SENTRY_DSN,
//     logLevel: 'error',
//     integrations: [new Integrations.BrowserTracing()],
//     tracesSampleRate: 1.0,
//     environment: process.env.REACT_APP_STAGE,
//   });
// }
localStorage.removeItem('conference-token');
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
